import { LinkedListEnhancedItem } from '@ahc-digital/component-library';
import { GetLinkedListEnhancedItemModel } from './C12LinkedListEnhancedItem.service';
import { translationClasses } from '@/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C12LinkedListEnhancedItemProps } from './C12LinkedListEnhancedItem.types';

const Default = (props?: C12LinkedListEnhancedItemProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = GetLinkedListEnhancedItemModel(props);
  return (
    <LinkedListEnhancedItem
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C12LinkedListEnhancedItemProps>(Default);
